import { Component, OnInit, Input } from '@angular/core';
import { Pick } from '../../../core/models/cart/pick.model';
import { Real } from '../../../core/models/real.model';
import { ShopDetailService } from '../../../core/services/shop-detail.service';
import { Employee } from '../../../core/models/employee.model';
import { TranslateService } from "@ngx-translate/core";

@Component({
  selector: 'app-summary',
  templateUrl: './summary.component.html',
  styleUrls: ['./summary.component.scss'],
})
export class SummaryComponent implements OnInit {

  @Input() pick: Pick;
  @Input() real: Real;
  @Input() hidePartySize: string;
  
  employees: Employee[];
  employeesMap: Object;

  constructor( private shopDetailService: ShopDetailService, public translateService: TranslateService ) { 

    shopDetailService.employees$.subscribe( 
      employees => { 
        this.employees = employees;
        this.employeesMap = this.shopDetailService.generateEmployeesMap( employees );
      }
    );

  }

 
  //@todo refactor -> similar method in slots.component
  getEmployeeFromEmployeeHref( href ) {
    
    if (!this.employeesMap) {
      return null;
    }

    let employeeId = href.substr( href.lastIndexOf("/") + 1 );
    if ( this.employeesMap[ employeeId ]) {
      return this.employeesMap[ employeeId ];
    } 

    return null;
  }

  ngOnInit() {
  }

}
